import type { FilterOption } from 'src/redux/filter/types/Filter';

export const getActiveFilterCountString = (count: FilterOption['activeCount']) => {
  if (count === null) {
    return '';
  }

  return `(${count > 999 ? '999+' : count})`;
};
